<cw-ci-data-table #brandDataTable
  tileTitle="Brands"
  refreshToolTip="Reload brand list"
  defaultSortField="name"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadBrands($event)"
  (selectHandler)="editBrand($event)"
  [items]="brandList">

  <cw-ci-table-column columnName="active" columnTitle="Active" [output]="activeTemplate" searchField="active" filterType="select" [filterOptions]="[{display:'Active', value:'true'}, {display:'Inactive', value:'false'}]"></cw-ci-table-column>
  <ng-template let-element #activeTemplate><mat-icon color="accent" *ngIf="element.isActive">check</mat-icon></ng-template>

  <cw-ci-table-column columnName="name" columnTitle="Name" sortField="name"></cw-ci-table-column>

  <cw-ci-table-column columnName="baseColor" columnTitle="Base Color" [output]="baseColorTemplate"></cw-ci-table-column>
  <ng-template let-element #baseColorTemplate><span [style.background]="element.baseColor" class="brand-color-cell"> {{ element.baseColor }}</span></ng-template>

  <cw-ci-table-column columnName="highlightColor" columnTitle="Highlight Color" [output]="highlightColorTemplate"></cw-ci-table-column>
  <ng-template let-element #highlightColorTemplate><span [style.background]="element.highlightColor" class="brand-color-cell"> {{ element.highlightColor }}</span></ng-template>

  <cw-ci-table-column columnName="textColor" columnTitle="Text Color" [output]="textColorTemplate"></cw-ci-table-column>
  <ng-template let-element #textColorTemplate><span [style.background]="element.textBackgroundColor" class="brand-color-cell"> {{ element.textBackgroundColor }}</span></ng-template>

  <cw-ci-table-column columnName="updatedAt" columnTitle="Updated" sortField="updated_at" [output]="updatedAtTemplate"></cw-ci-table-column>
  <ng-template let-element #updatedAtTemplate>{{element.updatedAt | date:'mediumDate':'+0000'}}</ng-template>

  <cw-ci-table-column columnName="createdAt" columnTitle="Created" sortField="created_at" [output]="createdAtTemplate"></cw-ci-table-column>
  <ng-template let-element #createdAtTemplate>{{element.createdAt | date:'mediumDate':'+0000'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action actionToolTip="Edit the brand" svgIcon="cw:action_edit" actionColor="primary" [element]="element" (clickHandler)="editBrand($event)"></cw-ci-table-column-action>
  </ng-template>

</cw-ci-data-table>
